import { useEffect, useState } from 'react';
export var usePollingToggle = function (shouldStartPolling) {
    var _a = useState(shouldStartPolling), isPollingEnabled = _a[0], setIsPollingEnabled = _a[1];
    useEffect(function () {
        if (shouldStartPolling && !isPollingEnabled) {
            setIsPollingEnabled(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldStartPolling]);
    return {
        isPollingEnabled: isPollingEnabled,
        setPollingOff: function () {
            setIsPollingEnabled(false);
        },
        setPollingOn: function () {
            setIsPollingEnabled(true);
        }
    };
};
